import { combineReducers } from 'redux'
import { attributeTables, identify, map, mapsources, publicSites, tabbedPanel } from 'catena/er2_map_userlayers/js/reducers'
import services from 'catena/er2_map_services/js/reducers/services'
import geoBar from './geo_bar'
import analyzeFrameworkBar from './analyze_framework_bar'
import analysisPanel from './analysis_panel'
import collaboration from './collaboration'
import collaborationSettings from './collaboration_settings'
import contextBar from './context_bar'
import digpop from './digpop'
import error from './error'
import header from './header'
import mapBaseLayer from './mapbaselayer'
import mapToolbar from './map_toolbar'
import meta from './meta'
import refugeeModel from './refugee_model'
import selectBookmarkBar from './select_bookmark_bar'
import selectFrameworkBar from './select_framework_bar'
import settingsBar from './settings'
import serverState from './server_state'
import tableOfContents from './table_of_contents'
import tableOfContentsFramework from './table_of_contents_framework'
import token from './token'
import transims from './transims'

const rootReducer = combineReducers({
    analyzeFrameworkBar,
    analysisPanel,
    attributeTables,
    collaboration,
    collaborationSettings,
    contextBar,
    digpop,
    error,
    geoBar,
    header,
    identify,
    map,
    mapBaseLayer,
    mapsources,
    mapToolbar,
    meta,
    publicSites,
    refugeeModel,
    selectBookmarkBar,
    selectFrameworkBar,
    serverState,
    services,
    settingsBar,
    tabbedPanel,
    tableOfContents,
    tableOfContentsFramework,
    token,
    transims,
})

export default rootReducer
